/** Office side of the customer portal: messages and notes from the law office / court, with reply. */
import { useState } from 'react';
import { api } from '../shared/api.ts';
import { useAuth } from '../shared/auth.tsx';
import { Card, ErrorBox, useAction, useLoad } from '../shared/ui.tsx';

const dt = (x: string) => new Date(x).toLocaleString('en-US', { month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });

export function PortalThread({ paperId, customerName }: { paperId: string; customerName: string | null }) {
  const { can } = useAuth();
  const r = useLoad(() => api.get<any>(`/api/papers/${paperId}/portal-posts?markRead=1`), [paperId]);
  const [text, setText] = useState('');
  const a = useAction();
  if (!customerName) return null;
  const posts = r.data?.posts ?? [];
  return (
    <Card title={`Portal: ${customerName}`} className="portal-thread-card">
      {posts.length === 0 && <p className="muted small">No messages or notes from the portal yet.</p>}
      <ul className="plain portal-thread">
        {posts.map((m: any) => (
          <li key={m.id} className={`${m.from_side} ${m.kind}`}>
            <div className="small muted">
              {m.kind === 'note' ? 'Note' : 'Message'} · {m.from_side === 'office' ? `Office (${m.author})` : `${m.author}, ${m.customer}`} · {dt(m.created_at)}
            </div>
            <div>{m.body}</div>
          </li>
        ))}
      </ul>
      {can('papers.intake') && (
        <form
          className="stack"
          data-unsaved={text ? 'true' : undefined}
          onSubmit={(e) => {
            e.preventDefault();
            a.run(async () => {
              await api.post(`/api/papers/${paperId}/portal-posts`, { body: text.trim() });
              setText('');
              r.reload();
            });
          }}
        >
          <textarea rows={2} aria-label="Reply to the customer" placeholder={`Reply to ${customerName}…`} value={text} onChange={(e) => setText(e.target.value)} />
          <div>
            <button className="btn sm primary" disabled={a.busy || !text.trim()}>
              Send reply
            </button>
          </div>
        </form>
      )}
      <ErrorBox error={a.error ?? r.error} />
    </Card>
  );
}
